import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

// About page sections
import {
  AboutBreadcrumb,
  DiscoverSection,
  AchievementsSection,
  AwardsSection,
  // TeamSection,
  SoftwareAssociates,
} from "../components/AboutPage";

// Core Principles section
import CorePrinciples from "../components/AboutPage/CorePrinciples/CorePrinciples";

const AboutPage = () => {
  return (
    <>
      {/* Header */}
      <Header />

      {/* Hero / Breadcrumb */}
      <AboutBreadcrumb label="Get To Know Us" />


      {/* About Intro */}
      <DiscoverSection />

      {/* Core Principles (Large content handled properly) */}
<CorePrinciples />

      {/* Achievements */}
      <AchievementsSection />

      {/* Awards */}
      <AwardsSection />

      {/* Team */}
      {/* <TeamSection /> */}

      {/* Software Associates */}
      <SoftwareAssociates />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default AboutPage;
